import { useFormikContext } from "formik";
import { IconLogin2, IconLogout2, IconCheck } from "@tabler/icons-react";
import { Button as BaseButton } from "@base-ui/react/button";
import Text from "../UI/Text";
import Title from "../UI/Title";
import Callout from "../UI/Callout";
import Card from "../UI/Card";
// @ts-expect-error pure js
import TabbedForm from "../UI/TabbedForm";
// @ts-expect-error pure js
import { classnames } from "../../utils";
import { ModalDialogBody } from "../UI/ModalDialog";
import styles from "./EdlTypeStep.module.css";

type EdlTypeValues = { type_edl: string };

const CHOICES = [
  {
    value: "Entrée",
    title: "État des lieux d'entrée",
    desc: "À la remise des clés, en début de location. Il sert de référence pour toute la durée du bail.",
    icon: IconLogin2,
  },
  {
    value: "Sortie",
    title: "État des lieux de sortie",
    desc: "Au départ du locataire, en fin de location. À comparer avec l'état des lieux d'entrée.",
    icon: IconLogout2,
  },
] as const;

export default function EdlTypeStep({ preavis }: { preavis?: boolean }) {
  const { values, setFieldValue } = useFormikContext<EdlTypeValues>();

  return (
    <>
      <ModalDialogBody>
        <div className={styles.container}>
          <div className={styles.head}>
            <Title variant="hecto" weight="bold">
              Quel état des lieux souhaitez-vous réaliser ?
            </Title>
            <Text>
              Ce choix détermine tout le document. Sélectionnez le type
              correspondant à votre situation.
            </Text>
          </div>

          <Callout variant="info">
            {preavis
              ? "Un préavis a été enregistré pour ce locataire : vous réalisez sans doute l'état des lieux de sortie."
              : "Aucun préavis n'est enregistré pour ce locataire : commencez par l'état des lieux d'entrée."}
          </Callout>

          <div className={styles.grid}>
            {CHOICES.map((choice) => {
              const selected = values.type_edl === choice.value;
              const Icon = choice.icon;
              return (
                <BaseButton
                  key={choice.value}
                  nativeButton={false}
                  onClick={() => setFieldValue("type_edl", choice.value)}
                  render={
                    <Card
                      checked={selected}
                      className={classnames(
                        styles.card,
                        selected && styles.selected,
                      )}
                    >
                      {selected && (
                        <span className={styles.check}>
                          <IconCheck size={16} />
                        </span>
                      )}
                      <div className={styles.cardTitle}>
                        <span className={styles.cardIcon}>
                          <Icon size={25} />
                        </span>
                        <Title variant="hecto" weight="bold" as="h3">
                          {choice.title}
                        </Title>
                      </div>
                      <Text>{choice.desc}</Text>
                    </Card>
                  }
                />
              );
            })}
          </div>
        </div>
      </ModalDialogBody>
      <TabbedForm.Actions sticky />
    </>
  );
}
